import AdminLayout from "../../components/admin/layout/AdminLayout";
import CreateBidForm from "../../components/admin/bids/CreateBidForm";

function CreateListingsPage() {
    return (
        <AdminLayout>
            <CreateBidForm />
        </AdminLayout>
    );
}

export default CreateListingsPage;